import type { SVGProps } from 'react';

const SvgUpgrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 12.973c.55 0 1-.45 1-1s-.45-1-1-1c-1.66 0-3-1.34-3-3 0-.55-.45-1-1-1s-1 .45-1 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1s.45 1 1 1c1.66 0 3 1.34 3 3 0 .55.45 1 1 1s1-.45 1-1c0-1.66 1.34-3 3-3m8-7c-1.1 0-2-.9-2-2 0-.55-.45-1-1-1s-1 .45-1 1c0 1.1-.9 2-2 2-.55 0-1 .45-1 1s.45 1 1 1c1.1 0 2 .9 2 2 0 .55.45 1 1 1s1-.45 1-1c0-1.1.9-2 2-2 .55 0 1-.45 1-1s-.45-1-1-1m-2.75 11.25c-.83 0-1.5-.67-1.5-1.5 0-.41-.34-.75-.75-.75s-.75.34-.75.75c0 .83-.67 1.5-1.5 1.5-.41 0-.75.34-.75.75s.34.75.75.75c.83 0 1.5.67 1.5 1.5 0 .41.34.75.75.75s.75-.34.75-.75c0-.83.67-1.5 1.5-1.5.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
    />
  </svg>
);
export default SvgUpgrade;
